<template>
		<section id="cinemas">
			<header>
				<h2>Seznam kin</h2>
			</header>
			<div class="content-wrapper">
				<ul v-for="(cinemas, city) in $store.getters.getCinemas">
					<li index="0">
						<strong class="btn" @click.prevent="toggleCity(city)">
							<span>{{city}}</span> <i></i><em>{{$store.getters.selectedCinemas(city).length}}/{{cinemas.length}}</em>
						</strong>
						<ul>
							<li :class="isActive(cinema)" v-for="cinema in cinemas">
								<a :href="href(cinema)" @click.prevent="toggleCinema(cinema)">{{cinema.name}}</a>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</section>
</template>

<script>
import axios from 'axios'

export default {
	data () {
		return {
		}
	},
	methods: {
		href: function (venue) {
			return `#${venue.slug}`
		},
		toggleCity: function (city) {
			this.$store.dispatch('toggleCity', city)
		},
		toggleCinema: function (cinema) {
			this.$store.dispatch('toggleCinema', cinema)
		},
		isActive: function (cinema) {
			return cinema.active ? 'active' : 'inactive'
		}
	},
	created: function () {
		const self = this
		axios.get(`${self.$store.getters.apiUrl}/cinema/`)
			.then(function (response) {
				self.$store.dispatch('cinemas', response.data.data)
			})
			.catch(function (error) {
				console.log(error)
			}
		)

		if (this.$route.params.id) {
			axios.get(`${self.$store.getters.apiUrl}/projection/detail/${this.$route.params.id}`)
				.then(function (response) {
					self.$store.commit('projection', response.data.data)
				})
				.catch(function (error) {
					console.log(error)
				}
			)
		}
	}
}
</script>

<style lang="less">
	@import "../assets/less/default.less";

	section#cinemas { width: 20vw;
		ul {
		> li { position: relative;
			strong { display: block; width: 80%; margin: 1ex auto; font-size: 24/15rem;
			em { .bottom-right(1.5ex,1.2ex); font-style: normal; font-size: 9/15rem; color: @grey; }
			}
		}
		ul {
			@tick: 3px solid white;
			li { padding: .5ex 0; font-family: "bebas-neue", sans-serif; font-size: 18/15rem; text-align: center; text-indent: 15px;
				a { color: #fff; position: relative; }
				&:hover { text-decoration: none;
					a {
					&:before { .top-right(0px,-20px); content: ""; display: inline-block; .size(13px,13px); border-left: @tick; transform: rotate(-45deg); }
					&:after { .top-right(0px,-13px); content: ""; display: inline-block; .size(13px,13px); border-bottom: @tick;  transform: rotate(-45deg);}
					}
				}
				&.inactive { opacity: .3;
					a:before, a:after { display: none; }
					&:hover { opacity: 1;
					a {
						&:before { display: none; }
						&:after { top: 5px; right: -20px; content: ""; display: inline-block; .size(13px,7px); border-bottom: @tick; border-left: @tick; transform: rotate(-45deg); vertical-align: middle; }
					}
					}
				}
			}
		}
		}
	}

	@media @tablet {
		section {
			&#cinemas { width: 50vw; min-width: 0; }
		}
	}

	@media @mobile {
		section#cinemas { width: 100vw; min-width: 0; border-color: @red; }
	}
</style>



// WEBPACK FOOTER //
// src/components/Cinemas.vue